// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"27":"ddc9e94f","443":"ad7f724d"}[chunkId] || chunkId) + "." + {"27":"dfa2d07c4f820086","443":"c12357a4ae95d132","460":"d8e0334c81002d13"}[chunkId] + ".js";
};